import {Component, OnInit, ViewChild, Input} from '@angular/core';
import {GridComponent} from "@syncfusion/ej2-angular-grids";
import {FilterSettingsModel, SelectionSettingsModel} from "@syncfusion/ej2-grids/src/grid/base/grid-model";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {DateAdapter} from "@angular/material/core";
import {OFXProvider} from "../../../../providers/bookkeeping/ofx/ofx";
import {Snackbar} from "../../../../util/snackbar";

@Component({
  selector: 'app-conciliacao-lote',
  templateUrl: './conciliacao-lote.component.html',
  styleUrls: ['./conciliacao-lote.component.scss']
})
export class ConciliacaoLoteComponent implements OnInit {

  @ViewChild('grid', {static: false}) grid: GridComponent;
  @Input() dataSourceMain: any;

  public filterSettings: FilterSettingsModel;
  public selectionSettings: SelectionSettingsModel;
  public filter: { type: string };
  public customAttributes: any;
  public enviando: boolean = false;
  public cardExpanded: boolean = true;
  public rowSelected: any[] = [];
  public lastOrder = {field: '', direction: '', searching: ""};
  public selectedTransactionAndPosting: any[] = [];
  public currentDate: string;

  constructor(
    public activeModal: NgbActiveModal,
    private _adapter: DateAdapter<any>,
    public ofxProvider: OFXProvider,
    public snackbar: Snackbar
  ) {
  }

  ngOnInit(): void {
    this._adapter.setLocale('pt-BR');
    this.customAttributes = {class: 'customcss'};
    this.filterSettings = {type: 'Menu'};
    this.filter = {type: 'CheckBox'};
    this.selectionSettings = {persistSelection: false, type: 'Multiple', checkboxOnly: true};
    this.currentDate = this.formatDate(new Date());

    // Initialize with all items selected
    this.selectedTransactionAndPosting = this.dataSourceMain ? [...this.dataSourceMain] : [];
  }

  private formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  setFirstPageTableData(event: any): void {
    this.rowSelected = [];
    if (event.rows !== undefined) {
      event.rows.forEach(row => {
        this.rowSelected.push(row.data);
      });
    }
  }

  formataValor(value: number): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  }

  actionBegin(args: any): void {
    if (args.requestType === 'filterchoicerequest') {
      args.filterChoiceCount = 1000000;
    }
    if (args.requestType === 'sorting') {
      this.lastOrder.field = args.columnName;
      this.lastOrder.direction = args.direction;
    }
    if (args.requestType === 'searching') {
      this.lastOrder.searching = args.searchString;
    }
  }

  autoFill(): void {
    this.grid.autoFitColumns([
      'date', 'description', 'value', 'posting'
    ]);
    this.grid.refreshHeader();
  }

  submit(): void {
    if (this.selectedTransactionAndPosting.length === 0) {
      this.snackbar.openLong('Selecione ao menos uma transação para conciliar', 'warning');
      return;
    }

    this.enviando = true;

    const data = this.selectedTransactionAndPosting.map((item) => {
      return {
        companyId: localStorage.getItem('idEmpresa'),
        ofxTransactionId: item.id,
        postingIds: [item.sugestion.id]
      }
    });

    this.ofxProvider.conciliateBatchTransactions(data)
      .then((result) => {
        this.snackbar.openLong(
          `${this.selectedTransactionAndPosting.length} ${this.selectedTransactionAndPosting.length === 1 ? 'transação conciliada' : 'transações conciliadas'} com sucesso!`,
          'success'
        );
        this.activeModal.close(true);
      })
      .catch((err) => {
        this.enviando = false;
        this.snackbar.openLong(
          'Erro ao conciliar lançamentos: ' + (err.error.error_description || 'Erro desconhecido'),
          'erro'
        );
      });
  }

  checkIfIsAllSelected(): boolean {
    const currentRecords = this.grid ? this.grid.getCurrentViewRecords() : [];
    if (currentRecords.length === 0) return false;

    return currentRecords.every(record =>
      this.selectedTransactionAndPosting.findIndex(val => val.id === record['id']) !== -1
    );
  }

  selectAllTransactionAndPosting(): void {
    const currentRecords = this.grid ? this.grid.getCurrentViewRecords() : [];

    if (this.checkIfIsAllSelected()) {
      // Remove all current page items from selection
      currentRecords.forEach(record => {
        const index = this.selectedTransactionAndPosting.findIndex(val => val.id === record['id']);
        if (index !== -1) {
          this.selectedTransactionAndPosting.splice(index, 1);
        }
      });
    } else {
      // Add all current page items to selection
      currentRecords.forEach(record => {
        const index = this.selectedTransactionAndPosting.findIndex(val => val.id === record['id']);
        if (index === -1) {
          this.selectedTransactionAndPosting.push(record);
        }
      });
    }
  }

  selectTransactionAndPosting(financialRelease: any): void {
    const index = this.selectedTransactionAndPosting.findIndex(val => val.id === financialRelease.id);

    if (index === -1) {
      this.selectedTransactionAndPosting.push(financialRelease);
    } else {
      this.selectedTransactionAndPosting.splice(index, 1);
    }
  }

  checkTransactionAndPostingSelected(financialRelease: any): boolean {
    return this.selectedTransactionAndPosting.findIndex(val => val.id === financialRelease.id) === -1;
  }

  getTotalValue(): number {
    return this.selectedTransactionAndPosting.reduce((sum, item) => sum + (item.value || 0), 0);
  }

  getSelectionText(): string {
    const count = this.selectedTransactionAndPosting.length;
    return count === 1 ? 'transação selecionada' : 'transações selecionadas';
  }

}
